import React from 'react';
import PropTypes from 'prop-types';
import ReduxModal from 'components/reduxModal';
import { Trans } from 'components';
import { withTranslated } from "components";

const MODAL_ID = 'invoice-address-add-success';

const AddInvoiceAddressInfo = ({ close, t }) => (
  <ReduxModal
    id={MODAL_ID}
  >
    {(Modal) => (
      <div>
        <Modal.Heading title={t("Nowy adres do faktury został dodany")} />
        <Modal.Footer>
          <button type="button" onClick={close} className="full-btn has-margin-left"><Trans>Ok, rozumiem</Trans></button>
        </Modal.Footer>
      </div>
    )}
  </ReduxModal>
);

AddInvoiceAddressInfo.propTypes = {
  close: PropTypes.func.isRequired
}

export default withTranslated(AddInvoiceAddressInfo);


// WEBPACK FOOTER //
// ./src/components/globalModals/AddInvoiceAddressInfo.jsx